import React from "react"
import EngineIDNavBar from "@components/EngineIDNavBar"
import BannerApps from "./BannerApps"
import Highlights from "./Highlights"
import Message from "@components/Message"
import ProblemStatement from "./ProblemStatement"
import CTASignUpLong from "@components/CTASignUpLong"
import Footer from "@components/Footer"
import "@styles/custom-bootstrap.scss"
import "@styles/global.scss"
import SEO from "@components/SEO"

const Apps = props => {

  return (
    <div>
      <SEO
        title={"EngineID integration with " + props.pathContext.appName}
        keywords={[
          props.pathContext.appName,
          props.pathContext.appName + ` saml`,
          props.pathContext.appName + ` synchronization`,
          props.pathContext.appName + ` provisioning`,
          `engineid`,
          `security`,
          `access to your applications`,
          `provision to cloud`,
          `permission management`,
          `single sign on`,
          `identity management`,
          `access management`,
        ]}
        description={"EngineID integrates seamlessly with " + props.pathContext.appName + ". Learn how "
        + "your users can reduce their login complexity with identity management."}
      />
      <EngineIDNavBar />
      <BannerApps pathContext={props.pathContext} />
      <div className={"maxWidth"}>
        <Highlights pathContext={props.pathContext} />
        <Message />
        <ProblemStatement />
      </div>
      <CTASignUpLong />
      <Footer />
      
    </div>
  )
}

export default Apps
